import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { useValueRef } from '@cian/react-utils';
import { useDropdownController, useFocusOptionController } from '../../../internal/hooks/controllers';
export function useSelectDesktopController(props) {
  const {
    open,
    actions: dropdownActions
  } = useDropdownController(props);
  const {
    focusedIndex,
    actions: focusOptionActions
  } = useFocusOptionController({
    length: props.options.length
  });
  const stateRef = useValueRef({
    props,
    open,
    focusedIndex
  });
  React.useEffect(() => {
    const {
      options,
      value
    } = stateRef.current.props;
    if (!open) {
      const selectedIndex = options.findIndex(option => value === option.value);
      focusOptionActions.setFocusedIndex(Math.max(selectedIndex, 0));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);
  const selectOption = index => {
    const {
      props
    } = stateRef.current;
    const option = props.options[index];
    if (!option) {
      return;
    }
    const optionValue = option.value;
    const prevValue = props.value;
    if (optionValue !== prevValue) {
      props.onChange(optionValue);
    }
  };
  const selectFocusedOption = () => selectOption(stateRef.current.focusedIndex);
  const actions = _objectSpread(_objectSpread(_objectSpread({}, dropdownActions), focusOptionActions), {}, {
    selectOption,
    selectFocusedOption
  });
  return {
    open,
    focusedIndex,
    actions
  };
}